import { render, staticRenderFns } from "./WordsOfWisdom.vue?vue&type=template&id=2e0054d0&"
import script from "./WordsOfWisdom.vue?vue&type=script&lang=js&"
export * from "./WordsOfWisdom.vue?vue&type=script&lang=js&"
import style0 from "./WordsOfWisdom.vue?vue&type=style&index=0&id=2e0054d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports